import React, { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import ManageUserAccessStore from '../../stores/ManageUserAccessStore';
import RouteUrlPaths from '../../RouteUrlPaths';

interface ProtectedConfirmPersonalDetailsRouteProps {
  manageUserAccessStore: ManageUserAccessStore;
}

const ProtectedConfirmPersonalDetailsRoute: FC<
  PropsWithChildren<ProtectedConfirmPersonalDetailsRouteProps>
> = (props) => {
  const { manageUserAccessStore, children } = props;

  if (!manageUserAccessStore.shouldForceConfirmPersonalDetails()) {
    return <Navigate to={RouteUrlPaths.Frontpage} />;
  }

  return children as React.ReactElement;
};

export default ProtectedConfirmPersonalDetailsRoute;
